import { ApiResponse } from '@mrp-system/common';
import { APIError } from 'error/APIError';

export const handleRequest: <U, T extends ApiResponse<U>>(
  callback: () => Promise<{ data: T; headers: any }>
) => Promise<T> = async (callback) => {
  const { data, headers } = await callback();

  if (data.status === 'SUCCESS' || data.status === 'WARNING') {
    return data;
  } else {
    throw new APIError(data.message, data, headers);
  }
};
